<template>
  <div class="custom-table">
    <div class="custom-table__actions"></div>
    <div class="custom-table__filter">
      <table-filter-client v-model="model" :schema="schema" />
      <div class="custom-table__filter_btns"></div>
    </div>
    <template v-if="showCloseModalFlag">
      <AccountCloseModal
        :close_item="this.closeItem"
        :close_mail="this.closeMail"
        :close_theme="this.closeTheme"
        :close_content="this.closeContent"
        :get_close_with_doc_mail="get_close_with_doc_mail"
        :hide_close_modal="hideCloseModal"
      />
      <div class="overlay" @click="hideCloseModal"></div>
    </template>
    <b-table
      hover
      striped
      class="custom-table__table"
      selectable
      select-mode="multi"
      responsive
      :fields="headers"
      :items="items"
      :busy="loading"
      ref="selectableTable"
      bordered
      :per-page="filters.limit"
      :tbody-tr-attr="rowColor"
      @row-clicked="toogleRow"
      sticky-header
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Загрузка...</strong>
        </div>
      </template>

      <template #head(selected)="">
        <b-checkbox @input="toogleAll" />
      </template>

      <template #cell(selected)="{ rowSelected }">
        <b-checkbox :checked="rowSelected" disabled />
      </template>

      <template #cell(invoice_id)="{ value }">
        <a :href="gen_link_invoice(value)">{{ value }}</a>
      </template>

      <template #cell(index)="{ index }">
        {{ index + 1 }}
      </template>
      <template #cell(agreement)="{ value }">
        {{ format_argeement(value) }}
      </template>
      <template #cell(list_uslug)="{ value, item }">
        <b-list-group>
          <b-list-group-item
            v-for="uslug in value"
            :key="getNameUslug(uslug.name, item.id)"
          >
            {{ uslug.name }} - {{ format_currency(item, uslug.price) }} X
            {{ uslug.quantity }}
          </b-list-group-item>
        </b-list-group>
      </template>

      <template #cell(company_own)="{ value }">
        {{ value.title }}
      </template>

      <template #cell(company)="{ value }">
        {{ value.title }}
      </template>

      <template
        v-slot:[`cell(${name})`]="{ value, field, item }"
        v-for="name in nameFiles"
      >
        <div class="btn-group" :key="genNameOpen(name)">
          <b-button
            @click="openLastFile(value)"
            class="reestr__btn_badge"
            size="sm"
            variant="outline-dark"
          >
            <span>посмотреть</span>
            <b-badge
              @click.stop="showModal(field.label, value)"
              class="reestr__badge"
              variant="info"
              >{{ value.length }}
            </b-badge>
          </b-button>

          <b-button
            v-if="get_status_view()"
            @click="addFile(field, item)"
            :key="genName(name)"
            class="btn btn-default"
            variant="success"
            size="sm"
          >
            <b-icon
              class="base-addable-file__btn_icon"
              size="sm"
              icon="cloud-upload"
              aria-hidden="true"
            />
            <input
              @change="sendFiles(item, field)"
              :id="genNameInput(name, item.invoice_id)"
              type="file"
              :name="genNameInput(name, item.invoice_id)"
              :multiple="true"
              style="display: none"
            />
          </b-button>
        </div>
      </template>

      <template #cell(real_upload_at)="{ item }">
        <b>
          {{ item.real_upload_at }}
        </b>
      </template>

      <template v-if="get_status_view()" #cell(defect)="{ item }">
        <b-button
          :active="!item.defect"
          :variant="colorButtonDefect(item.defect)"
          @click="toggle_defect(item.invoice_id)"
        >
          <b> Да </b>
        </b-button>
      </template>

      <template v-if="get_status_view()" #cell(one_c)="{ item }">
        <b-button
          :active="!item.one_c"
          @click="get_one_c(item.invoice_id)"
          :variant="colorButtonDefect(item.one_c)"
        >
          Отправить в 1С
        </b-button>
      </template>

      <template v-if="get_status_view()" #cell(close)="{ item }">
        <b-button
          class="close-button"
          :active="!item.close"
          @click="get_close(item)"
          :variant="colorButtonDefect(item.close)"
        >
          Закрыть в ЭДО
        </b-button>
        <div v-if="item.has_files">
          <b-button
            class="close-button"
            :active="!item.close"
            @click="showCloseModal(item)"
            :variant="colorButtonDefect(item.close)"
          >
            Закрыть с отправкой
          </b-button>
        </div>
      </template>
    </b-table>

    <table-paginate
      v-model="page"
      :totalItems="totalItems"
      @changeLimit="limit = $event"
    />
    <files-modal
      :title="modalFiles.title"
      :files="modalFiles.files"
      v-model="modalFiles.state"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { headers } from "./constants/tableHeaders";

import FilesModal from "@/components/modals/FilesModal.vue";
import PaginateMixin from "@/mixins/PaginateMixin";
import TableSelectMixin from "@/mixins/TableSelectMixin";
import ClientReestrApi from "@/services/api/ClientReestrApi";
import { model, schema } from "./constants/filter.ts";
import nameFiles from "./constants/nameFiles";
import FileAction from "@/helpers/FileAction";
import Cookies from "vue-cookies";
import AccountCloseModal from "@/components/modals/AccountCloseModal.vue";

export default Vue.extend({
  name: "PageClients",
  // eslint-disable-next-line vue/no-unused-components
  components: { AccountCloseModal, FilesModal },
  mixins: [PaginateMixin, TableSelectMixin],
  data() {
    return {
      closeItem: null,
      closeMail: null,
      closeTheme: null,
      closeContent: null,
      showCloseModalFlag: false,
      loading: false,
      headers,
      items: [],
      schema,
      page_view_local: false,
      model,
      nameFiles,
      modalFiles: {
        state: false,
        files: [],
        title: "",
      },
    };
  },

  methods: {
    showCloseModal(item) {
      this.closeItem = item;
      this.closeMail = item.contact_email;
      this.closeContent = `Здравствуйте, направляем в Ваш адрес сканы первичных бухгалтерских документов.
Оригиналы документов отправлены почтой.
С Уважением к Вам и к Вашему бизнесу!`;
      this.closeTheme = "Первичные бухгалтерские документы";
      this.showCloseModalFlag = true;
    },
    hideCloseModal() {
      this.showCloseModalFlag = false;
    },
    async fetch() {
      this.loading = true;
      const search = { ...this.model, ...this.model.date };
      delete search.date;

      const params = { ...search, ...this.filters };
      ClientReestrApi.clientSearch(params)
        .then((res) => {
          this.totalItems = res.size;
          this.items = res.res;
          this.loading = false;
          setTimeout(this.initTable.bind(this), 100);
        })
        .catch(console.error);
    },

    async fetch_not_reload() {
      this.loading = false;
      const search = { ...this.model, ...this.model.date };
      delete search.date;
      const params = { ...search, ...this.filters };
      ClientReestrApi.clientSearch(params)
        .then((res) => {
          this.totalItems = res.size;
          this.items = res.res;
          this.loading = false;
          setTimeout(this.initTable.bind(this), 100);
        })
        .catch(console.error);
    },
    gen_link_invoice(id) {
      return "https://b24.datrans.ru/crm/type/31/details/" + id + "/";
    },
    format_currency(fmt_str, price) {
      if (typeof fmt_str.currency == "undefined") return price;
      else return fmt_str.currency.replace("#", price);
    },
    format_argeement(value) {
      if (value) {
        return "Да";
      } else {
        return "Нет";
      }
    },
    rowColor(item, type) {
      if (!item || type !== "row") return;
      // || type !== "row"
      return { style: `background: ${item.state_invoice}` };
    },
    list_uslug(list_uslug) {
      if (list_uslug.length > 0) {
        return list_uslug.join("<br>");
      }
      return "";
    },
    get_one_c(id) {
      ClientReestrApi.setStatusOneC({ id: id })
        .then(() => {
          this.fetch_not_reload();
          this.makeNotification("Действие", "Счет выставлен в 1С", "success");
        })
        .catch(console.error);
    },
    async get_close(item) {
      const url = "https://lk-dev.datrans.ru/api/send_close_invoice";
      const data = {
        contact_id: item.contact_id,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Указываем, что отправляем JSON
          },
          body: JSON.stringify(data), // Преобразуем данные в JSON-строку
        });

        if (!response.ok) {
          throw new Error("Ошибка при отправке письма на почту");
        }
      } catch (error) {
        console.error("Ошибка:", error);
      }

      ClientReestrApi.setStatusClose({ id: item.invoice_id })
        .then((res) => {
          this.fetch_not_reload();
          this.makeNotification("Действие", "Счет закрыт", "success");
        })
        .catch(console.error);
    },
    async get_close_with_doc_mail(item, mail, theme, content) {
      this.hideCloseModal();
      const url = "https://lk-dev.datrans.ru/api/send_close_invoice_with_doc";
      const data = {
        id: item.invoice_id,
        contact_id: item.contact_id,
        mail: mail,
        theme: theme,
        content: content,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Указываем, что отправляем JSON
          },
          body: JSON.stringify(data), // Преобразуем данные в JSON-строку
        });

        if (!response.ok) {
          throw new Error("Ошибка при отправке письма на почту");
        }
      } catch (error) {
        console.error("Ошибка:", error);
      }

      ClientReestrApi.setStatusClose({ id: item.invoice_id })
        .then((res) => {
          this.fetch_not_reload();
          this.makeNotification("Действие", "Счет закрыт", "success");
        })
        .catch(console.error);
    },
    get_status_view() {
      // Vue.use(Cookies);
      // this.page_view_local = Vue.$cookies.get("page_view");
      // return this.page_view_local;
      return true;
    },
    toggle_defect(id) {
      ClientReestrApi.setStatusDefect({ id: id })
        .then((res) => {
          this.fetch_not_reload();
          this.makeNotification(
            "Действие",
            "Установлен статус 'дефектный'",
            "success"
          );
        })
        .catch(console.error);
    },

    addRealDate(id, date) {
      ClientReestrApi.setRealUploadAt({ id: id, date_upload: date })
        .then((res) => {
          this.fetch_not_reload();
          this.makeNotification(
            "Действие",
            "Установлен статус 'дефектный'",
            "success"
          );
        })
        .catch(console.error);
    },
    genName(name) {
      return name + "-add-file";
    },
    genNameInput(name, id) {
      return name + "-add-file-input_" + id;
    },
    getNameUslug(name, id) {
      return name + "-uslug-" + id;
    },
    openLastFile(files) {
      FileAction.open(files[files.length - 1].path);
    },
    showModal(label, files) {
      this.modalFiles.state = true;
      this.modalFiles.files = files;
      this.modalFiles.title = label;
    },
    addFile(field, value) {
      let id_input = this.genNameInput(field.key, value.invoice_id);
      document.getElementById(id_input).click();
    },
    genNameOpen(item) {
      return "button-open-file-" + item;
    },
    colorButtonDefect(flag) {
      if (flag == 0) {
        return "primary";
      } else {
        return "none";
      }
    },
    sendFiles(item, field) {
      let id_input = this.genNameInput(field.key, item.invoice_id);
      let input = document.getElementById(id_input);
      let files = input.files;
      let form = new FormData();
      if (typeof files != "undefined") {
        form.append("id", item.invoice_id);
        form.append("type", field.key);
        Array.from(files).forEach((file) => form.append("documents[]", file));
        ClientReestrApi.addFiles(form)
          .then(() => {
            this.fetch_not_reload();
            this.makeNotification("Действие", "Файлы добавлены", "success");
          })
          .catch(() => {
            this.makeNotification(
              "Ошибка",
              "Не удалось добавить файлы",
              "danger"
            );
          });
      }
    },
  },

  async mounted() {
    this.fetch();
  },

  watch: {
    filters() {
      this.fetch_not_reload();
    },
    model: {
      handler() {
        this.fetch_not_reload();
      },
      deep: true,
    },
  },
});
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    0,
    0,
    0,
    0.5
  ); /* Четвертое значение (0.5) задает прозрачность */
  z-index: 999; /* Поднимаем слой над остальным содержимым */
}

.overlay-button {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный фон для затемнения */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Установите очень высокий уровень z-index */
}

.overlay-button button {
  /* Стилизация кнопки */
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
}
.close-button {
  margin: 10px;
}
</style>
